/**
 * TypeVehicle
 */
export class TypeVehicle {

  /**
   * type
   */
  type: string;

  /**
   * name
   */
  name: string;

  /**
   * Create instance from JSON
   *
   * @param json Object
   *
   * @returns TypeVehicle instance
   */
  static createFromJson(json: object): TypeVehicle {
    const self = new this();

    Object.keys(json).forEach(key => {
      self[key] = json[key];
    });

    return self;
  }

}
